import { render } from "./ListaSensores.vue?vue&type=template&id=2e96ea4a&scoped=true"
import script from "./ListaSensores.vue?vue&type=script&lang=js"
export * from "./ListaSensores.vue?vue&type=script&lang=js"

import "./ListaSensores.vue?vue&type=style&index=0&id=2e96ea4a&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/opt/vue/ped/ped-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e96ea4a"]])

export default __exports__